import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ServiceHelper } from '../../helper/services.helper';

@Component({
    selector: 'app-help-icon',
    templateUrl: './help-icon.component.html',
    styleUrls: ['./help-icon.component.scss'],
})
export class HelpIconComponent {

    @Output() helpClicked: EventEmitter<void> = new EventEmitter<void>();

    @Input() helpText?: string;
    @Input() title?: string;
    @Input() small?: boolean;


    showHelp(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.helpClicked.observers?.length > 0) {
            this.helpClicked.emit();
        } else {
            ServiceHelper.displayAlert(this.title ?? 'Help', this.helpText ?? 'No help text provided');
        }
    }

}